module.exports = __webpack_public_path__ + "img/bg6.5c5bfa78.jpg";